import React from 'react';
import { Empty, Icon } from 'antd';
import Btn from '../../../../../../../components/btn';
import styles from './FetchError.module.scss';

const baseMsg =
  'Если это не первая попытка, проверьте соединение с интернетом или обратитесь в поддержку';

const FetchError = ({ message, refetch }) => {
  return (
    <Empty
      className={styles.root}
      image={
        <Icon
          type="close-circle"
          className={styles.icon}
        />
      }
      description={
        <span className={styles.description}>
          <span>{message}.</span>
          <br />
          <span>{baseMsg}</span>
        </span>
      }
    >
      <Btn onClick={refetch}>Попробовать снова</Btn>
    </Empty>
  );
};

export default FetchError;
